import React, { useEffect, useState } from "react";
import Header from "../../componets/Header";
import { Link, useLoaderData, useNavigate } from "react-router-dom";
import { FaCircleArrowLeft } from "react-icons/fa6";
import {
	Button,
	Card,
	CardBody,
	Col,
	Container,
	Row,
	Table,
} from "react-bootstrap";
import AlertService from "../../helper/alertService";
import ApiService from "../../helper/api";
import ConfigForm from "./ConfigForm";
import MainService from "../../helper/mainService";

function Component(props) {
	const { configs } = useLoaderData();
	const [data, setData] = useState([]);
	const [disabledButton, setDisabledButton] = useState(null);
	const navaigate = useNavigate();
	const [isShowForm, setIsShowForm] = useState({
		open: false,
		config: null,
	});

	useEffect(() => {
		configGetAll();
	}, []);

	// useEffect(() => {
	// 	if (configs?.length) {
	// 		setData(configs);
	// 	}
	// }, [configs]);

	const configGetAll = () => {
		MainService.callApi({
			api: ApiService.configGetAll,
			cb: response => {
				if (response && response.data && response.data.length) {
					setData(response.data);
				}
			},
		});
	};

	const closeModal = () => {
		setIsShowForm({ open: false, config: null });
	};

	const configDelete = id => {
		setDisabledButton(id);
		AlertService.alertConfirm("Are you sure ?")
			.then(res => {
				MainService.callApi({
					api: ApiService.configDelete,
					data: id,
					cb: res => {
						if (res.success) {
							AlertService.alert("success", "Data seved");
							setData(data => data.filter(item => item.id !== id));
						}
					},
					_finally: () => {
						setDisabledButton(null);
					},
				});
			})
			.catch(error => {})
			.finally(() => {});
	};

	return (
		<div>
			<Header>
				<div className="d-flex justify-content-between w-100 flex-wrap">
					<div className="d-flex gap-2 align-items-center">
						<Link to="/">
							<FaCircleArrowLeft size={20} />
						</Link>
						<h4 className="mb-0">Configs</h4>
					</div>
					<Link
						to={"#"}
						type="button"
						className="btn btn-primary btn-sm"
						onClick={() => {
							setIsShowForm({
								open: true,
								config: null,
							});
						}}>
						+ Add config
					</Link>
				</div>
			</Header>
			<Card className="mt-3">
				<CardBody>
					<Table id="table" responsive hover className="mt-0">
						<thead>
							<tr>
								<th>#</th>
								<th>Name</th>
								<th>Value</th>
								<th>Description</th>
								<th>Default</th>
								<th>Readonly</th>
								<th>Action</th>
							</tr>
						</thead>
						<tbody>
							{!!data &&
								!!data.length &&
								data.map((item, index) => (
									<tr
										key={index}
										onClick={() => {
											// navaigate(`/network-analyze?symbol=${item.symbol}`);
										}}>
										<td>{index + 1}</td>

										<td>{item.name}</td>
										<td>{item.value}</td>
										<td>{item.description}</td>
										<td className="text-center">
											{item.isDefault ? "✅" : "❌"}
										</td>
										<td className="text-center">
											{item.isReadonly ? "✅" : "❌"}
										</td>

										<td>
											<div className="d-flex gap-2">
												<Button
													variant="primary"
													size="sm"
													className="px-3"
													onClick={() => {
														setIsShowForm({
															open: true,
															config: item,
														});
														// getNetworkPlatformByid(item.id);
													}}>
													Edit
												</Button>
												<Button
													variant="danger"
													size="sm"
													className="px-3"
													// disabled={item.id === disabledButton}
													onClick={() => {
														configDelete(item.id);
													}}>
													Delete
												</Button>
											</div>
										</td>
									</tr>
								))}
						</tbody>
					</Table>
				</CardBody>
			</Card>
			<ConfigForm
				confige={isShowForm.config}
				isShowForm={isShowForm.open}
				closeModal={closeModal}
				setData={setData}
			/>
		</div>
	);
}

const loader = async () => {
	return [];
};

const Configs = Object.assign(Component, { loader });

export default Configs;
